export function resolveApiEndpoint (functionName: string) {
    return `/api/${functionName}`;
}